// extracted by mini-css-extract-plugin
module.exports = {"valueDisplay":"style__valueDisplay__REmko"};